import React from 'react'
import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/OverviewHeight/OverviewHeight'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'
import { CaseCTAItem } from 'components/cases/common/CaseCTA'
import { CaseDownloadCTAItem } from 'components/cases/common/CaseDownloadCTA'

// ファーストビュー
export const firstViewItemWhite = {
  breadcrumb: '不動産売買の契約業務をDX化 - UX/UI刷新でミスを削減し、作業時間を大幅に短縮',
  title1: (
    <>
      不動産売買の契約業務をDX化
      <br />- UX/UI刷新でミスを削減し、作業時間を大幅に短縮
    </>
  ),
  company: '株式会社不動産SHOP ナカジツ',
  introduction_text: (
    <>
      株式会社不動産SHOP
      ナカジツは、営業スタッフによる「物件調査および契約書作成」という、不動産売買における極めて重要なプロセスの刷新を検討していました。同社では、紙の調査票や契約書作成システムを併用しており、ムダな転記作業が発生している状況でした。また、チェック品質が担当者のスキルに依存するなど、属人的なフローによって業務効率・品質・組織拡張の面でも課題を抱えていました。
      <br />
      こうした状況を受け、Aitriaは、物件調査票の作成から契約書作成・承認に至るまでの一連の業務に対し、UX/UI設計とシステム開発支援を包括的にワンストップでご支援しました。
    </>
  ),
  tag1text: 'アプリケーション開発',
  tag1src: '/cases/application-development/',
  tag2text: 'フロントエンド開発',
  tag2src: '/cases/frontend-dev/',
  tag3text: 'UX/UI改善',
  tag3src: '/cases/uxui-improvement/',
  tag4text: '内製化支援',
  tag4src: '/cases/inhouse-support/',
  industryTagText: '金融/不動産',
  industryTagSrc: '/cases/finance/',
  image: '/images/img/cases/nakajitsu/mv.webp',
  movie: '',
  alt: '不動産売買の契約業務をDX化 ーUX/UI刷新でミスを削減し、作業時間を大幅に短縮',
}

// プロジェクト概要
export const overviewTitle = '事業拡大に伴い、非効率な業務フローと属人化という課題感が顕著に'

export const overviewItem: OverviewItems[] = [
  {
    text: '不動産売買において、契約書は売主・買主それぞれの権利義務を明確化する重要な文書であり、取引の安全性・信頼性を確保するためには非常に丁寧な記載が求められます。 ',
  },
  {
    text: 'また、土地・建物・マンション・仲介売買・個人売買など、取引の形態が多岐にわたるため、契約書・調査票に必要な項目・書式も複数存在。法令・特約・建物構造・既存住宅瑕疵など、専門知識や判断を要する項目が多く、精度の高い情報整理が求められる領域でもあります。',
  },
  {
    text: 'こうした背景において、株式会社不動産SHOP ナカジツ（以下、不動産SHOP ナカジツ）では営業スタッフが紙の物件調査票に手書き入力し、その後契約書作成システムへ手動で転記するという非効率な作業が発生していました。また、調査結果・契約書のチェックが管理者のスキルレベルに左右されやすいという課題もありました。さらに、営業エリア・店舗数の増加により、若手スタッフの割合が増え、教育・チェックの負荷が一層高まっていました。',
  },
  {
    text: '不動産SHOP ナカジツは中長期的な事業拡大を見据え、全国への店舗展開と売上拡大を目標に掲げる中で、社内全体でDX推進に取り組んでいます。本プロジェクトは、そうした中長期目標の実現に向けたDX推進施策の一環として始動しました。',
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        text2:
          '業界知識の理解が必要な業務であるにも関わらずナレッジ共有が十分にできておらず、経験やスキルによって作業品質にばらつきが生じていた。',
      },
      {
        text2:
          '紙ベースの手書き記入や書類チェック、システムへの転記作業など、アナログなプロセスが多く業務効率が低下していた。',
      },
      {
        text2: 'チェック工程が煩雑で時間がかかり、管理者への負担が大きかった。',
      },
      {
        text2: '拠点や人員の拡大に対して、既存の業務フローや運用体制が追いつかなくなっていた。',
      },
    ],
    solutions: [
      {
        text2: (
          <>
            現場の業務フローを丁寧に分析し、<span>入力・確認のしやすさを重視したデジタル化</span>
            を実現。誰でもミスなく業務を回せる仕組みを設計。
          </>
        ),
      },
      {
        text2: (
          <>
            分断されていたシステムや工程を連携させ、調査票作成から契約書承認までの<span>効率的なフローを構築</span>。
          </>
        ),
      },
      {
        text2: (
          <>
            <span>チェック業務をスムーズに行えるUX/UI設計</span>で品質とスピードを両立。
          </>
        ),
      },
      {
        text2: (
          <>
            現場の声を反映しながら、<span>属人化しない運用体制</span>を設計。組織拡大にも柔軟に対応できる仕組みを整備。
          </>
        ),
      },
    ],
    outcomes: [
      {
        title: '調査精度が向上し、再調査の手戻りの数が削減。',
      },
      {
        title: '契約書作成に要する作業時間を大幅に短縮。',
      },
      {
        title: '若手スタッフのスキルレベルの向上と同時に、管理者の負担軽減を実現。',
      },
    ],
  },
]

// CTA
export const caseCTAItem: CaseCTAItem = {
  title: '業務の属人化、解消しませんか？',
  description:
    '業界特有の複雑な業務フローを丁寧に読み解いた上で、AI駆動でのUX/UI設計とシステム開発をワンストップでご支援します。まずは、現在の課題やお悩みをお聞かせください。',
}

// 資料ダウンロード CTA
export const caseDownloadCTAItem: CaseDownloadCTAItem = {
  title: 'アプリ開発RFP作成のポイント',
  description: 'アプリ開発担当者向けに、失敗しないためのポイントをテンプレート付の1冊にまとめました',
  imageSrc: '/images/img/cases/cta_rfp.webp',
  href: '/download/rfp/',
}

// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
